{
  "name": "websites-list-app",
  "private": true,
  "version": "2.4.0",
  "scripts": {
    "dev": "vite",
    "build": "tsc --noEmit && eslint . && vite build",
    "preview": "vite preview",
    "typecheck": "tsc --noEmit",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "test": "vitest run",
    "test:watch": "vitest",
    "postbuild": "node postBuild.js",
    "prepare": "husky || true"
  },
  "lint-staged": {
    "*.{ts,tsx}": "eslint --fix",
    "**/*": "prettier --write --ignore-unknown"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "dependencies": {
    "@reduxjs/toolkit": "^2.8.2",
    "react": "^19.2.6",
    "react-dom": "^19.2.6",
    "react-redux": "^9.3.0"
  },
  "devDependencies": {
    "@types/node": "^25.9.1",
    "@types/react": "^19.2.16",
    "@types/react-dom": "^19.2.3",
    "@vitejs/plugin-react": "^6.0.2",
    "@vitest/eslint-plugin": "^1.6.19",
    "eslint": "^9.39.4",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-react-refresh": "^0.4.26",
    "globals": "^17.6.0",
    "husky": "^9.1.7",
    "jsdom": "^29.1.1",
    "lint-staged": "^17.0.5",
    "prettier": "^3.8.3",
    "sass": "^1.100.0",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.60.1",
    "vite": "^8.0.14",
    "vitest": "^4.1.8"
  }
}
